// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__-Vzn1","employee-header__buttons":"Header_employee-header__buttons__GnmtB","employee-header-item":"Header_employee-header-item__uyWeQ"};